export default "__VITE_ASSET__BfyaZzTx__"